export interface ProductBillOfMaterial {
  id: string;
  key: string;
  description: string;
  oldCode: string;
  productType: string;
  stdPrice: number;
  calculatedStdCost: number;
  onOrder: number;
  balance: number;
  allocated: number;
  unAllocated: number;
  unitOfMeasure: string;
  orderNo: string;
  orderDate: Date;
  customerKey: string;
  customerName: string;
  orderQuantity: number;
  orderPrice: number;
  orderValue: number;
  orderSterlingValue: number;
  orderStatus: string;
  currencyCode: string;
  currencySymbol: string;
}
